import { useMemo } from "react";
import {
  Hammer,
  Wrench,
  Paintbrush,
  Ruler,
  Scissors,
  Drill,
  HardHat,
  Pipette,
  Plug,
  ScanLine,
  Shovel,
  Cog,
  Bolt,
  Flashlight,
  Brush,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

const TOOLS: LucideIcon[] = [
  Hammer, Wrench, Paintbrush, Ruler, Scissors, Drill,
  HardHat, Pipette, Plug, ScanLine, Shovel, Cog,
  Bolt, Flashlight, Brush,
];

interface StaticTool {
  id: number;
  x: number;
  y: number;
  size: number;
  color: string;
  rotation: number;
  toolIdx: number;
  opacity: number;
}

export default function StaticToolBackground() {
  const tools = useMemo<StaticTool[]>(() => {
    const colors = [
      "hsl(215, 65%, 22%)",
      "hsl(215, 65%, 34%)",
      "hsl(24, 75%, 50%)",
      "hsl(215, 55%, 44%)",
      "hsl(24, 65%, 58%)",
      "hsl(215, 45%, 52%)",
    ];

    // Seeded pseudo-random for consistent layout
    let seed = 42;
    const rand = () => {
      seed = (seed * 16807 + 0) % 2147483647;
      return (seed - 1) / 2147483646;
    };

    return Array.from({ length: 28 }, (_, i) => ({
      id: i,
      x: 2 + rand() * 96,
      y: 2 + rand() * 96,
      size: 26 + rand() * 34,
      color: colors[i % colors.length],
      rotation: Math.floor(rand() * 360),
      toolIdx: i % TOOLS.length,
      opacity: 0.1 + rand() * 0.1,
    }));
  }, []);

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none -z-10" aria-hidden="true">
      {tools.map((tool) => {
        const Icon = TOOLS[tool.toolIdx];
        return (
          <div
            key={tool.id}
            className="absolute"
            style={{
              left: `${tool.x}%`,
              top: `${tool.y}%`,
              opacity: tool.opacity,
              transform: `rotate(${tool.rotation}deg)`,
            }}
          >
            <Icon
              size={tool.size}
              color={tool.color}
              strokeWidth={1.2}
            />
          </div>
        );
      })}
    </div>
  );
}
